<div class="container" style="background-image: linear-gradient(rgba(255, 255, 255, 0.8),rgba(255, 255, 255, 0.8)), url('../../assets/img/sobre.png');
background-repeat: no-repeat; background-position: center center; min-height: 600px;">
  <section>
    <div class="air"></div>
    <div class="forms">
      <h5 class="text-center" [ngStyle]="{'color': authenticationService.localStorageItem('letra')}" style="font-weight: bold; padding-top: 30px;">Formulario de Contacto</h5>
      <form (ngSubmit)="onSubmit(contactForm, 'Contacto');" #contactForm="ngForm">
        <mat-form-field>
          <input matInput placeholder="Nombre" #nombre maxlength="80" [(ngModel)]="ContactModel.dato3" name="Name" required>
          <mat-hint align="end">{{nombre.value?.length || 0}}/80</mat-hint>
        </mat-form-field>
        <mat-form-field>
          <input matInput placeholder="Email" type="email" [(ngModel)]="ContactModel.dato4" name="Email" [email]="true" required>
        </mat-form-field>
        <mat-form-field>
          <input matInput placeholder="Teléfono" #tel type="tel" [(ngModel)]="ContactModel.dato5" name="Phone" maxlength="16">
          <mat-hint align="end">{{tel.value?.length || 0}}/16</mat-hint>
        </mat-form-field>
        <mat-form-field>
          <input matInput placeholder="Asunto" #asunto maxlength="60" [(ngModel)]="ContactModel.dato6" name="Subject" required>
          <mat-hint align="end">{{asunto.value?.length || 0}}/60</mat-hint>
        </mat-form-field>
        <mat-form-field>
          <textarea matInput placeholder="Mensaje" #msn maxlength="2000" [(ngModel)]="ContactModel.dato7" name="Msn" cols="25" required></textarea>
          <mat-hint align="end">{{msn.value?.length || 0}}/2000</mat-hint>
        </mat-form-field>
        <button mat-raised-button color="primary" [disabled]="!contactForm.form.valid">Enviar</button>
      </form>
    </div>
  </section>
</div>
<app-pie></app-pie>
